export const cancelExport = Symbol();
export const MAX_GROUP_DEPTH = 3; //  3 groups + 1 row
